import { h } from "preact";

const IconRight = ({ color = "#788391" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fill-rule="evenodd">
        <path fill={color} d="M8 7.4L9.4 6l6 6-6 6L8 16.6l4.6-4.6z" />
        <path d="M0 0h24v24H0z" />
      </g>
    </svg>
  );
};

export default IconRight;



// WEBPACK FOOTER //
// ./assets/images/IconRight.js